<template>
  <article class="gc-brand" @click="navigate">
    <div class="gc-brand-media">
      <img :src="image" :alt="brand.name || 'Brand'" loading="lazy" />
    </div>
    <div class="gc-brand-body">
      <h3>{{ brand.name }}</h3>
    </div>
  </article>
</template>

<script>
import Store from "../../services/store";

export default {
  name: "BrandItem",

  props: ["grid", "brand", "iheight"],

  methods: {
    getOriginalAssetURL(data, sid) {
      return Store.getOriginalAssetURL(data, sid);
    },

    navigate() {
      this.$router
        .push({
          name: "brand",
          params: { slug: this.brand.slug || this.brand._id },
        })
        .catch(() => {});
    },
  },

  computed: {
    image() {
      if (!this.brand || !this.brand.file) return this.lazy;
      return this.getOriginalAssetURL(this.brand.file, this.brand.store);
    },
  },

  data() {
    return {
      lazy: require("@/assets/imgs/placeholder.png"),
    };
  },
};
</script>
